import { render } from "./Indikator.vue?vue&type=template&id=7afc1274"
import script from "./Indikator.vue?vue&type=script&lang=js"
export * from "./Indikator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__